// extracted by mini-css-extract-plugin
export default {"nameLine":"styles_nameLine__rPgsJ"};